import React from "react";
import { CheckCircle } from "lucide-react";

const PlacementBanner = () => {
  return (
    <section className="bg-gradient-to-r from-sky-100 via-white to-sky-50 py-16 px-6 mt-4">
      <div className="max-w-6xl mx-auto flex flex-col-reverse md:flex-row items-center gap-12">
        {/* Left: Text Content */}
        <div className="flex-1 text-center md:text-left">
          <span
            className="inline-block bg-sky-600 text-white text-sm font-semibold px-4 py-1 rounded-full mb-4 shadow"
            aria-label="Placement Badge"
          >
            💼 100% Job Placement
          </span>

          <h2 className="text-3xl sm:text-4xl font-extrabold text-sky-800 leading-tight mb-4">
            We don’t just teach,<br />we help you get hired.
          </h2>

          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            Circuitcy offers complete support in resume building, mock interviews,
            and real-world projects. Our dedicated placement team ensures every learner
            is ready to step into the industry with confidence.
          </p>


        </div>

        {/* Right: Icon or Image */}
        <div className="flex-1 flex justify-center">
          <CheckCircle className="w-40 h-40 text-sky-500 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default PlacementBanner;
